export default __webpack_public_path__ + "static/media/ProvisioningPicture_Blue.c733cd5f.png";